import React from "react"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"

const rows = (p) => [
  p.name && [null, p.name],
  p.risk_type && ["Risk", p.risk_type],
  p.status && ["Status", p.status],
  p.as_of && ["As of", p.as_of],
  p.note && ["Note", p.note],
]

export default function HighRisk(props) {
  return (
    <CoreZoneLayer
      flag="HighRisk"
      path="highrisk"
      title="High Risk Area"
      style={{ fillColor: "red", color: "red", weight: 2 }}
      rows={rows}
      {...props}
    />
  )
}
